import { render, staticRenderFns } from "./PollsStatisticsResume.vue?vue&type=template&id=806ecc34"
import script from "./PollsStatisticsResume.vue?vue&type=script&lang=ts"
export * from "./PollsStatisticsResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports